import * as actionTypes from 'modules/audits/actionTypes';
import type { PayloadAction } from 'modules/global/generic.types';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

import type { AuditWithEvents } from './utils';
import { isAuditWithEvents } from './utils';
import type { PaginatedAuditEvent } from '../../types/projections/paginated-audit-event';

const auditEventAdapter = createEntityAdapter<PaginatedAuditEvent>({ selectId: ({ id }) => id as string });

export const initialState = auditEventAdapter.getInitialState();

const removeAuditEvents = (state: typeof initialState, { payload: auditId }: PayloadAction<string>) =>
  auditEventAdapter.removeMany(
    state,
    state.ids.filter(eventId => state.entities[eventId].auditId === auditId),
  );

const reset = () => auditEventAdapter.getInitialState();

export default createReducer(
  initialState,
  {
    [actionTypes.DELETE_SUCCESS]: removeAuditEvents,
    [LOCATION_CHANGE]: reset,
  },
  [
    {
      matcher: isAuditWithEvents,
      reducer: (state, { payload }: PayloadAction<AuditWithEvents>) =>
        auditEventAdapter.updateMany(state, payload.events),
    },
  ],
);
